import { rest } from 'msw';

import { OdinSubscriptionDetails } from 'interfaces/odinTypes';
import { getConfig } from 'shared/config';
import { local } from 'shared/utils/storage/local-storage';

import { handlers as hooksHandlers } from 'api/netCrackerAPI/mocks/handlers';
import { handlers as navigationApiHandlers } from 'components/navigation/mocks/handlers';
import { handlers as subscriptionAddonsApiHandlers } from 'components/SubscriptionAddons/mocks/handlers';
import { handlers as subscriptionSettingsApiHandlers } from 'components/SubscriptionSettings/mocks/handlers';
import { handlers as billingApiHandlers } from 'pages/Billing/mocks/handlers';
import { handlers as broadbandApiHandlers } from 'pages/Broadband/mocks/handlers';
import { handlers as emailApiHandlers } from 'pages/Email/mocks/handlers';
import { handlers as landlineApiHandlers } from 'pages/Landline/mocks/handlers';
import { handlers as mobileApiHandlers } from 'pages/Mobile/mocks/handlers';
import { handlers as mobileSubscriptionSettingsApiHandlers } from 'pages/Mobile/SubscriptionSettings/mocks/handlers';
import { handlers as overviewApiHandlers } from 'pages/Overview/mocks/handlers';
import { handlers as paymentMethodApiHandlers } from 'pages/PaymentMethod/mocks/handlers';
import { handlers as settingsApiHandlers } from 'pages/Settings/mocks/handlers';
import { handlers as tvApiHandlers } from 'pages/TV/mocks/handlers';

const odinApiHandlers = [
  rest.get(
    `${getConfig().odin?.host}/yousee/selfcare/subscriptions/:subscriptionId`,
    (req, res, ctx) => {
      const details: OdinSubscriptionDetails = {
        subscriptionId: req.params.subscriptionId as string,
        // @ts-ignore
        product: {
          productName: 'Mock data',
          recurringPrice: 42,
        },
      };

      return res(ctx.json(details));
    },
  ),
];

export type HandlerSetting = 'mock' | 'array' | 'object' | 'fail' | 'original';

export const handlers = [
  ...navigationApiHandlers,
  ...settingsApiHandlers,
  ...billingApiHandlers,
  ...paymentMethodApiHandlers,
  ...overviewApiHandlers,
  ...emailApiHandlers,
  ...hooksHandlers,

  // handlers for specific subscription IDs must be before the generic ones
  ...mobileApiHandlers,
  ...mobileSubscriptionSettingsApiHandlers,
  ...broadbandApiHandlers,
  ...tvApiHandlers,
  ...landlineApiHandlers,

  // parameterised (generic) handlers must be last
  ...odinApiHandlers,
  ...subscriptionAddonsApiHandlers,
  ...subscriptionSettingsApiHandlers,
].map((handler) => {
  // @ts-ignore
  const originalResolver = handler.resolver;
  // @ts-ignore
  handler.resolver = async function resolver(req, res, ctx) {
    try {
      const setting = (local.get(`mocksetting_${handler.info.path}`) as HandlerSetting) || 'mock';

      switch (setting) {
        case 'array':
          return res(ctx.json([]));
        case 'object':
          return res(ctx.status(204));
        case 'fail':
          throw new Error('Request failure (for testing purposes).');
        case 'original': {
          const originalcall = await ctx.fetch(req);
          return res(ctx.json(await originalcall.json()), ctx.status(originalcall.status));
        }
        default:
          return await originalResolver(req, res, ctx);
      }
    } catch (error: any) {
      const status = error.status || 500;
      return res(
        ctx.status(status),
        ctx.json({ status, message: error.message || 'Unknown Error' }),
      );
    }
  };
  return handler;
});
